<template>
    <v-card style="height: 100%; max-height: 100%;  overflow-y: auto" class="ma-0 pa-0" flat>
      <v-row class="ma-0 pa-0" style="width: 100%;" align="center">
        <v-col cols="auto" align="center" justify="center">
          <span class="report-subtitle">Volume vs Efficiency</span>
        </v-col>
        <!-- <v-spacer></v-spacer>
        <v-col cols="auto" align="center" justify="center">
          <v-btn disabled icon>
            <v-icon color="black">mdi-cog</v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="12" class="ma-0 pa-0" style="height: 10px;">
          <v-divider class="mx-12"></v-divider>
        </v-col>
        <v-col cols="12" v-if="!graph_visible">
          <v-skeleton-loader
                      light
                      :style="{
                        height: screenHeight + 'px',
                      }"
                      type="image,image,image,image"
            ></v-skeleton-loader>
        </v-col>
        <v-col v-if="graph_visible" :cols="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" style="height: 90%">
              <v-col cols="12" class="chartAlign">
                <div
                      :style="{
                        height: screenHeight + 'px',
                      }"
                    >   
                      <v-chart 
                        class="performanceChart"
                        :option="graph_options"
                        autoresize
                        :ref="chart_ref"
                        :id="chart_id"
                      ></v-chart>
                  </div>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
    </v-card>
  </template>
  
  <script>  
  // Configs
  // import cpalette from "@/configs/ChartColors/get_color_palette.js";
    import VChart, { THEME_KEY } from 'vue-echarts';
    import "echarts";
    import { use } from 'echarts/core';
    import { CanvasRenderer } from 'echarts/renderers';
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    } from 'echarts/components';
    import {
      PERFORMANCE_AXIS_LABEL,
      PERFORMANCE_AXIS_LINE,
      PERFORMANCE_AXIS_NAME,
      PERFORMANCE_CHART_COLORS,
      PERFORMANCE_SPLIT_LINE,
    } from "./performanceChartStyle.js";

    use([
        CanvasRenderer,
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    ]);
  
  export default {
    name: "VolumeVsEfficiency",
    props: [
      'data_version',
      'dataset',
      'color_palette',
      'available_adunits',
      'chart_ref',
      'chart_id',
      'chart_update_key'
    ],
    components: {
        VChart
    },
    provide: {
        [THEME_KEY]: 'light',
    },
    data: () => ({
      filter_menu: false,
      graph_visible: false,
      graph_data: null,
      spend_impr_contribution_overview_comments: false,
      spend_impr_contribution_col_size: 12,
      screenHeight: window.innerHeight * 0.55,

      selected_adunits: [],
      adunit_updates: 0
    }),
    mounted() {
      this.graph_data = this.dataset;
      if(this.dataset != null){
        this.reload_graph();
      }
    },
    watch: {
      dataset: {
        immediate: false,
        handler: function () {
          this.graph_data = this.dataset;
          if(this.dataset != null){
            this.reload_graph();
          }
        },
        deep: false,
      },
      selected_adunits: {
        immediate: false,
        handler: function () {
          this.adunit_updates += 1;
          setTimeout(() => {
            this.adunit_updates -= 1; 
            if(this.adunit_updates == 0){
              this.$emit('ve_levels', this.selected_adunits);
            }
          }, 2000);
        },
      },
      available_adunits: {
        immediate: false,
        handler: function () {
          this.selected_adunits = this.available_adunits;
        },
      }
    },
    computed: {
      graph_options: function() {
        
        let dataset = [... this.graph_data]
        let data_category = []
        

        if(dataset != null){
          data_category = dataset[0]
          dataset.shift()

          let pointSize = null
          for(let i = 0; i < dataset.length; i++){
            if(dataset[i][2]) {
              pointSize =  dataset[i][2].replace('point', "").replace('size:','').replace('{',"").replace("}","")
              dataset[i][2] = parseFloat(pointSize)*1.15
            }
          }

        }
        let hline_idx = data_category.indexOf('hline')
        const markline_options = {
          animation: false,
          lineStyle: {
            color: '#94a3b8',
            width: 1,
            type: 'dashed'
          },
          data: [
              { xAxis: dataset[dataset.length - 3][0] },
              { yAxis: dataset[dataset.length - 1][hline_idx] }
            ]
        };

        let series = [
          {
            data: dataset,
            type: 'scatter',
            markLine: markline_options,
            symbolSize: function (data) {
              return data[2]
            },
            label: {
              show: true,
              formatter: function (param) {
                return param.data[3];
              },
              position: 'top',
              color: '#334155',
              fontWeight: 500,
              fontSize: 13,
              fontFamily: 'Poppins'
            },
            labelLayout: {
              hideOverlap: true
            }
          },
          // quadrant labels
          {
            data: [
              [dataset[dataset.length-8][0], dataset[dataset.length - 8][5], 0,  dataset[dataset.length-8][6]],
              // [dataset[dataset.length-7][0], dataset[dataset.length - 7][5], 0,  dataset[dataset.length-7][6]],
              [dataset[dataset.length-6][0], dataset[dataset.length - 6][5], 0,  dataset[dataset.length-6][6]],
              // [dataset[dataset.length-5][0], dataset[dataset.length - 5][5], 0,  dataset[dataset.length-5][6]],
            ],
            type: 'scatter',
            symbolSize: 0,
            label: {
              show: true,
              formatter: function (param) {
                return param.data[3];
              },
              position: 'right',
              color: '#64748b',
              fontSize: 14,
              fontWeight: 600,
              fontFamily: 'Poppins'
            }
          },
          {
            data: [
              // [dataset[dataset.length-8][0], dataset[dataset.length - 8][5], 0,  dataset[dataset.length-8][6]],
              [dataset[dataset.length-7][0], dataset[dataset.length - 7][5], 0,  dataset[dataset.length-7][6]],
              // [dataset[dataset.length-6][0], dataset[dataset.length - 6][5], 0,  dataset[dataset.length-6][6]],
              [dataset[dataset.length-5][0], dataset[dataset.length - 5][5], 0,  dataset[dataset.length-5][6]],
            ],
            type: 'scatter',
            symbolSize: 0,
            label: {
              show: true,
              formatter: function (param) {
                return param.data[3];
              },
              position: 'left',
              color: '#64748b',
              fontSize: 14,
              fontWeight: 600,
              fontFamily: 'Poppins'
            }
          },
        ]

        const graph_option = {
            tooltip: {
              backgroundColor: "rgba(15, 23, 42, 0.92)",
              borderWidth: 0,
              textStyle: {
                color: "#ffffff",
                fontFamily: "Poppins",
                fontSize: 13,
              },
              formatter: function (param) {
                return param.data[4];
              }
            },
            color: [PERFORMANCE_CHART_COLORS[2]],
            grid: {
                left: '3%',
                right: '3%',
                bottom: '8%',
                top: 26,
                containLabel: true
            },
            xAxis: {
              name: 'ROAS ($)',
              nameTextStyle: PERFORMANCE_AXIS_NAME,
              type: 'value',
              axisLine: PERFORMANCE_AXIS_LINE,
              splitLine: PERFORMANCE_SPLIT_LINE,
              nameLocation: 'middle',
              nameGap: 34,
              max: dataset[dataset.length-5][0],
              axisLabel: {
                ...PERFORMANCE_AXIS_LABEL,
                formatter: function (value) {
                  if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                  if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                  if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                  return '$' + value.toFixed(1);
                }
              },
            },
            yAxis: {
              name: 'Contribution ($)',
              nameTextStyle: PERFORMANCE_AXIS_NAME,
              nameLocation: 'middle',
              nameGap: 58,
              type: 'value',
              axisLine: PERFORMANCE_AXIS_LINE,
              splitLine: PERFORMANCE_SPLIT_LINE,
              max: dataset[dataset.length-5][5],
              axisLabel: {
                ...PERFORMANCE_AXIS_LABEL,
                formatter: function (value) {
                  if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                  if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                  if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                  return '$' + value.toFixed(1);
                }
              },
            },
            series: series,
            // color: COLOR_PALETTE
        }
        return graph_option
      },
    },
    methods: {
      reload_graph: function () {
        this.graph_visible = false;
        setTimeout(() => (this.graph_visible = true), 10);
      },
    },
  };
  </script>
  
  <style scoped>
    .report-subtitle {
      font-family: "Poppins";
      font-weight: 600;
      font-size: 1.05em;
      color: #1e293b;
    }
    .chartAlign {
      margin: auto 0
    }
    .performanceChart {
      height: 100%;
      width: 100%;
    }
  </style>
  
